export default __webpack_public_path__ + "static/media/serviceSmall.e590a605.png";